import React, { useState } from "react";
import JModal from "./JModal/JModal";

type ConfirmWrapProps = {
  message: string;
  labelOk: string;
  labelCancel: string;
  children?: React.ReactNode;
};

function ConfirmWrap({
  children,
  message,
  labelOk,
  labelCancel,
}: ConfirmWrapProps) {
  const [modalActive, setModalActive] = useState(false);
  const child: any = React.Children.only(children);
  const handleShow = () => {
    setModalActive(true);
  };
  const handleClose = () => {
    setModalActive(false);
  };
  const handleConfirm = () => {
    if (child.props.onClick) child.props.onClick();
    setModalActive(false);
  };

  return (
    <>
      {React.cloneElement(child, {
        onClick: handleShow,
      })}
      {modalActive && (
        <JModal
          message={message}
          labelOk={labelOk}
          labelCancel={labelCancel}
          onConfirm={handleConfirm}
          onClose={handleClose}
        />
      )}
    </>
  );
}

export default ConfirmWrap;
